export enum OrderType {
    Delivery = "delivery",
    PickUp = "pickup",
}
